import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAccessToken, getRefreshToken, getTgAccessToken } from "src/api";
import { getUser } from "src/api/user/profile";
import { setUserProfile } from "src/store/profile/profileSlice";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetUserData = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const tgAccessToken = getTgAccessToken();
  const hasBrowserAuth = !!accessToken && !!refreshToken;
  const hasTgAuth = !!tgAccessToken;
  const dispatch = useDispatch()
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [QUERYKEYS.USER],
    queryFn: () => getUser(),
    enabled: hasBrowserAuth || hasTgAuth,
    // Пока запрос идёт, приложение показывает экран загрузки, поэтому ждём
    // недолго: одна повторная попытка переживает короткий сбой бэкенда, дальше
    // показываем интерфейс, а не бесконечную загрузку.
    retry: 1,
    retryDelay: 1000,
  });

  useEffect(() => {
    if(data?.data?.id){
      dispatch(setUserProfile(data?.data))
    }
  }, [data]);

  return {
    isSuccess,
    data,
    isError,
    isLoading,
    // Профиль есть только если запрос реально вернул пользователя.
    user: data?.data?.id ? data.data : null,
    refetchUserData: refetch,
  };
};
